(() => {
  const getSelectedColor = () => {
    const optionLabels = document.querySelectorAll('[data-option-name]');
    let colorIndex = -1;
    optionLabels.forEach((label, i) => {
      if (['color', 'colour'].includes(label.getAttribute('data-option-name').toLowerCase())) {
        colorIndex = i;
      }
    });
    if (colorIndex === -1) return null;
    const checked = document.querySelectorAll('input.js-variant-radio-item:checked');
    return checked[colorIndex]?.value ?? null;
  };

  const getVariants = () => {
    const el = document.querySelector('sht-variant-radios script[type="application/json"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  };

  const getFeaturedMediaIds = () => {
    const variants = getVariants();
    if (!variants) return new Set();
    const color = getSelectedColor();
    if (!color) return new Set();
    const regex = buildRegex(color);
    return new Set(
      variants
        .filter(v => regex.test(v.options.join(' ')))
        .filter(v => v.featured_media)
        .map(v => String(v.featured_media.id))
    );
  };

  const getAllColorRegexes = () => {
    const variants = getVariants();
    if (!variants) return [];
    const optionLabels = document.querySelectorAll('[data-option-name]');
    let colorIndex = -1;
    optionLabels.forEach((label, i) => {
      if (['color', 'colour'].includes(label.getAttribute('data-option-name').toLowerCase())) {
        colorIndex = i;
      }
    });
    if (colorIndex === -1) return [];
    return [...new Set(variants.map(v => v.options[colorIndex]))]
      .map(color => buildRegex(color));
  };

  const buildRegex = color =>
    new RegExp(`\\b${color.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');

  const shouldShow = (el, regex, allColorRegexes, featuredMediaIds) => {
    const img = el.querySelector('img');
    if (!img) return false;
    const alt = img.getAttribute('alt') || '';

    if (regex.test(alt)) return true;
    if (allColorRegexes.some(r => r.test(alt))) return false;

    const mediaId = (el.getAttribute('data-media-target-id') || el.getAttribute('data-media-id') || '').split('-').pop();
    return featuredMediaIds.has(mediaId);
  };

  const filterElements = (elements, regex, allColorRegexes, featuredMediaIds) => {
    elements.forEach(el => {
      if (shouldShow(el, regex, allColorRegexes, featuredMediaIds)) {
        el.style.removeProperty('display');
        el.classList.remove('vf-hidden');
      } else {
        el.classList.add('vf-hidden');
      }
    });
  };

  const showAll = () => {
    document.querySelectorAll('sht-vert-carousel-itm.js-product-slideshow-thumb').forEach(el => {
      el.style.removeProperty('display');
      el.classList.remove('vf-hidden');
    });
    document.querySelectorAll('sht-carousel-itm.js-product-slideshow-item').forEach(el => {
      el.style.removeProperty('display');
      el.classList.remove('vf-hidden');
    });
  };

  const getVisibleSlides = () =>
    Array.from(document.querySelectorAll('sht-gallery-slide.js-gallery-slide:not(.vf-hidden)'));

  const getVisibleCarouselItems = () =>
    Array.from(document.querySelectorAll('sht-carousel-itm.js-product-slideshow-item:not(.vf-hidden)'));

  const updateDialogNavigation = () => {
    const visibleSlides = getVisibleSlides();
    const total = visibleSlides.length;
    if (!total) return;

    const totalEl = document.querySelector('.js-slide-total');
    const currentEl = document.querySelector('.js-slide-current');
    const prevBtn = document.querySelector('.js-slide-prev-btn');
    const nextBtn = document.querySelector('.js-slide-next-btn');
    if (!totalEl || !currentEl) return;

    totalEl.textContent = total;

    const activeSlide = document.querySelector('sht-gallery-slide.js-gallery-slide.is-active-gallery-slide');
    if (!activeSlide) return;

    const currentPos = visibleSlides.indexOf(activeSlide) + 1;
    currentEl.textContent = currentPos;
    prevBtn && (currentPos <= 1 ? prevBtn.setAttribute('disabled', 'disabled') : prevBtn.removeAttribute('disabled'));
    nextBtn && (currentPos >= total ? nextBtn.setAttribute('disabled', 'disabled') : nextBtn.removeAttribute('disabled'));
  };

  let counterObserver = null;
  let correctTotal = null;

  const watchMobileCounterTotal = () => {
    const totalEl = document.querySelector('.js-carousel-counter-total');
    if (!totalEl || counterObserver) return;

    counterObserver = new MutationObserver(() => {
      if (correctTotal !== null && totalEl.textContent != correctTotal) {
        totalEl.textContent = correctTotal;
      }
    });

    counterObserver.observe(totalEl, { childList: true, subtree: true, characterData: true });
  };

  const updateMobileCounter = () => {
    const totalEl = document.querySelector('.js-carousel-counter-total');
    if (!totalEl) return;
    correctTotal = getVisibleCarouselItems().length;
    totalEl.textContent = correctTotal;
    watchMobileCounterTotal();
  };

  const patchDialogNavigation = () => {
    const prevBtn = document.querySelector('.js-slide-prev-btn');
    const nextBtn = document.querySelector('.js-slide-next-btn');
    if (!prevBtn || !nextBtn || prevBtn.dataset.vfPatched) return;

    prevBtn.dataset.vfPatched = 'true';
    nextBtn.dataset.vfPatched = 'true';

    const navigate = direction => {
      const visibleSlides = getVisibleSlides();
      if (!visibleSlides.length) return;

      const activeSlide = document.querySelector('sht-gallery-slide.js-gallery-slide.is-active-gallery-slide');
      const currentIndex = visibleSlides.indexOf(activeSlide);
      const nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;

      if (nextIndex < 0 || nextIndex >= visibleSlides.length) return;

      const nextSlide = visibleSlides[nextIndex];
      document.querySelectorAll('sht-gallery-slide.js-gallery-slide').forEach(slide => {
        slide.classList.remove('is-active-gallery-slide', 'd-flex');
        slide.classList.add('d-none');
      });

      nextSlide.classList.add('is-active-gallery-slide', 'd-flex');
      nextSlide.classList.remove('d-none');
      updateDialogNavigation();
    };

    prevBtn.addEventListener('click', e => { e.stopImmediatePropagation(); navigate('previous'); }, true);
    nextBtn.addEventListener('click', e => { e.stopImmediatePropagation(); navigate('next'); }, true);
  };

  const watchMobileCarousel = () => {
    const carousel = document.querySelector('.product-slideshow__items');
    if (!carousel) return;

    let scrollTimer = null;

    carousel.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const items = getVisibleCarouselItems();
        if (!items.length) return;

        const carouselCenter = carousel.getBoundingClientRect().left + carousel.getBoundingClientRect().width / 2;

        const mostVisible = items.reduce((closest, item) => {
          const itemCenter = item.getBoundingClientRect().left + item.getBoundingClientRect().width / 2;
          const distance = Math.abs(itemCenter - carouselCenter);
          return distance < closest.distance ? { item, distance } : closest;
        }, { item: null, distance: Infinity }).item;

        if (!mostVisible) return;

        const mediaId = mostVisible.getAttribute('data-media-id');
        document.querySelectorAll('sht-vert-carousel-itm.js-product-slideshow-thumb').forEach(thumb => {
          thumb.classList.toggle('is-active-item', thumb.getAttribute('data-media-target-id') === mediaId);
        });

        const currentEl = document.querySelector('.js-carousel-counter-current');
        if (currentEl) currentEl.textContent = items.indexOf(mostVisible) + 1;
      }, 100);
    });
  };

  const filterAll = color => {
    if (!color) return;
    const regex = buildRegex(color);
    const allColorRegexes = getAllColorRegexes();
    const featuredMediaIds = getFeaturedMediaIds();

    document.querySelector('.product-slideshow__thumbs, .thumbnail__horizoltal')?.classList.remove('vf-filter-active');

    filterElements(
      document.querySelectorAll('sht-vert-carousel-itm.js-product-slideshow-thumb'),
      regex, allColorRegexes, featuredMediaIds
    );

    document.querySelectorAll('sht-vert-carousel-itm.js-product-slideshow-thumb').forEach(thumb => {
      const mediaTargetId = thumb.getAttribute('data-media-target-id');
      if (!mediaTargetId) return;
      const carouselItem = document.querySelector(`sht-carousel-itm[data-media-id="${mediaTargetId}"]`);
      if (!carouselItem) return;
      if (shouldShow(thumb, regex, allColorRegexes, featuredMediaIds)) {
        carouselItem.style.removeProperty('display');
        carouselItem.classList.remove('vf-hidden');
      } else {
        carouselItem.classList.add('vf-hidden');
      }
    });

    filterElements(document.querySelectorAll('sht-gallery-slide.js-gallery-slide'), regex, allColorRegexes, featuredMediaIds);
    filterElements(document.querySelectorAll('sht-horiz-carousel-itm.js-gallery-thumb'), regex, allColorRegexes, featuredMediaIds);

    updateDialogNavigation();
    updateMobileCounter();
    patchDialogNavigation();
  };

  const init = () => {
    const thumbContainer = document.querySelector('.product-slideshow__thumbs, .thumbnail__horizoltal');
    if (!thumbContainer) return;

    const thumbs = document.querySelectorAll('sht-vert-carousel-itm.js-product-slideshow-thumb');
    if (!thumbs.length) return;

    thumbContainer.classList.add('vf-filter-active');

    let lastColor = null;
    let intervalId = null;
    let inactivityTimer = null;

    const startPolling = () => {
      if (intervalId) return;
      intervalId = setInterval(check, 200);
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(stopPolling, 30000);
    };

    const stopPolling = () => {
      clearInterval(intervalId);
      intervalId = null;
    };

    const check = () => {
      const color = getSelectedColor();

      // No color option on this product — show everything and stop
      if (!color) {
        thumbContainer.classList.remove('vf-filter-active');
        showAll();
        stopPolling();
        return;
      }

      if (color !== lastColor) {
        lastColor = color;
        filterAll(color);
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(stopPolling, 30000);
      }
    };

    check();
    setTimeout(check, 100);
    setTimeout(check, 300);
    setTimeout(check, 600);

    startPolling();

    document.querySelectorAll('input.js-variant-radio-item, .js-variant-radio-item').forEach(el => {
      el.addEventListener('click', () => startPolling());
    });

    document.addEventListener('click', e => {
      const opener = e.target.closest('.js-product-media-open-gallery-btn');
      if (!opener) return;
      setTimeout(() => {
        const color = getSelectedColor();
        if (color) filterAll(color);
        patchDialogNavigation();
        updateDialogNavigation();

        const dialogMediaId = opener.getAttribute('data-dialog-media-id');
        if (dialogMediaId) {
          document.querySelectorAll('sht-horiz-carousel-itm.js-gallery-thumb').forEach(thumb => {
            const btn = thumb.querySelector('button');
            const thumbMediaId = btn?.getAttribute('data-target');
            thumb.classList.toggle('is-active-gallery-thumb', thumbMediaId === dialogMediaId);
          });
        }
      }, 150);
    });

    setTimeout(watchMobileCarousel, 500);
  };

  // Update second/hover image when color swatch is clicked
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('.js-variant-swatch-item');
    if (!swatch) return;
    const secondImgUrl = swatch.getAttribute('data-second-image');
    if (!secondImgUrl) return;
    const card = swatch.closest('.product-card');
    if (!card) return;
    const secondImg = card.querySelector('.img-second');
    if (!secondImg) return;
    secondImg.src = secondImgUrl;
    secondImg.srcset = secondImgUrl;
  });

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();